import {
  WeblogicServices,
  Storage_ModelConfig_StorageType,
  Storage_ModelResource_State as UploadResultState,
} from '@quan/proto-api-client';

import { UploadParams, QiniuReq, TencentCloudReq, AliReq, safeProtocol } from './storage_service';

const { CosAuth } = require('@quan/libs/tx_storage');
const { Base64, AliCrypto } = require('@quan/libs/ali_storage');

// TODO 这里代码可以优化一下

/**
 * 获取当前oss上传地址和参数
 * @param preUploadReq
 */
async function getUploadUrlAndParams(
  preUploadReq: storage.UploadResourceReq,
  options?: { [key: string]: any },
) {
  const resp = await WeblogicServices.PreUpload(preUploadReq, options);
  const { storage_type, qn_token, tc_token, ali_token, resource } = resp;
  let uploadUrl = '';
  let uploadParams: UploadParams = null;

  switch (storage_type!) {
    case Storage_ModelConfig_StorageType.StorageTypeQiniu:
      uploadUrl = safeProtocol(qn_token!.upload_url!);
      uploadParams = {
        token: qn_token!.token,
        key: resource!.path!,
        domain: resource!.domain!,
      } as QiniuReq;
      break;
    case Storage_ModelConfig_StorageType.StorageTypeTCCloud:
      uploadUrl = safeProtocol(tc_token!.upload_url!);
      uploadParams = {
        Signature: CosAuth({
          SecretId: tc_token!.secret_id!,
          SecretKey: tc_token!.secret_key!,
          Method: 'POST',
          Pathname: '/',
        }),
        key: resource!.path!,
        'x-cos-security-token': tc_token!.token!,
        'Content-Type': resource!.content_type!,
      } as TencentCloudReq;
      break;
    case Storage_ModelConfig_StorageType.StorageTypeAliyun:
      uploadUrl = safeProtocol(ali_token!.upload_url!);

      // 1天上传有效期
      // eslint-disable-next-line no-var
      var policyText = {
        expiration:
          new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().replace(/\..+/, '') +
          'Z', // 设置Policy的失效时间，如果超过失效时间，就无法通过此Policy上传文件 格式ISO8601 GMT
        conditions: [
          ['content-length-range', 0, 1048576000], // 设置上传文件的大小限制，如果超过限制，文件上传到OSS会报错
        ],
      };
      // eslint-disable-next-line no-var
      var policy = Base64.encode(JSON.stringify(policyText));

      // eslint-disable-next-line no-var
      var bytes = AliCrypto.HMAC(
        // @ts-ignore
        AliCrypto.SHA1,
        policy,
        ali_token!.access_key_secret,
        {
          asBytes: true,
        },
      );

      // eslint-disable-next-line no-var
      var signature = AliCrypto.util.bytesToBase64(bytes);

      uploadParams = {
        key: resource!.path,
        policy,
        OSSAccessKeyId: ali_token!.access_key_id,
        signature,
        success_action_status: '200',
        'x-oss-security-token': ali_token!.token,
      } as AliReq;
      break;
    default:
      break;
  }

  return {
    uploadUrl,
    uploadParams,
    resp,
  };
}

/**
 * 通过getUploadUrlAndParams返回的id调用次方法，获取上传完成的地址
 * @param req
 */
async function getUploadResult(
  req: storage.UploadResourceCallBackReq,
  options?: { [key: string]: any },
) {
  return WeblogicServices.UploadCallBack(req, options);
}

export {
  getUploadUrlAndParams as weblogic_getUploadUrlAndParams,
  UploadParams as weblogic_UploadParams,
  UploadResultState as weblogic_UploadResultState,
  getUploadResult as weblogic_getUploadResult,
};
